// extracted by mini-css-extract-plugin
module.exports = {"input-video":"styles__input-video___2m8Bs","hide":"styles__hide___2czB8"};